// 导入封装好的网络请求类工具
import service from "./axios";

// 获取手机验证码
export const getAuthCode = data => {
  return service({
    url: "/apply/sendCode",
    method: "post",
    params: {
      phone: data
    },
    code: "v4"
  });
};

// 注册
export const register = data => {
  return service({
    url: "/apply/register",
    method: "post",
    data,
    code: "v4"
  });
};

// 修改密码
export const resetPwd = data => {
  return service({
    url: "/apply/resetPassword",
    method: "post",
    params: data,
    code: "v4"
  });
};



// WEBPACK FOOTER //
// ./src/api/register.js